// reveal animation for each image with the selector [lazy]
const revealObserver = () => {

  let images = document.querySelectorAll('[reveal]');
  let rootMargin = -(document.documentElement.clientHeight / 10)

  const config = {
    root: null, // avoiding 'root' or setting it to 'null' sets it to default value: viewport
    rootMargin: rootMargin + 'px',
    // rootMargin: '0px',
    // threshold: 0.5
    threshold: 0
  };

  let isLeaving = false;

  let observer = new IntersectionObserver(function(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // we are ENTERING the "capturing frame". Set the flag.
        isLeaving = true;
        
        entry.target.classList.add('in-view');

      } else if (isLeaving) {
        // we are EXITING the "capturing frame"
        isLeaving = false;
      }
    })
  }, config);

  images.forEach(image => {
      observer.observe(image);
  });

}


export {revealObserver};